import { render, staticRenderFns } from "./TextAreaForm.vue?vue&type=template&id=0704229e&"
import script from "./TextAreaForm.vue?vue&type=script&lang=js&"
export * from "./TextAreaForm.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaForm.vue?vue&type=style&index=0&id=0704229e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports